import React, { useEffect } from "react";
import styles from "./style.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  togglePlayPause,
  skipForward,
  skipBackward,
} from "../../../state/radioReducer";
import {
  RiForward10Fill,
  RiPauseFill,
  RiPlayFill,
  RiReplay10Fill,
} from "react-icons/ri";

export default function RadioPlayControls() {
  const dispatch = useDispatch();
  const isPlaying = useSelector((state: RootState) => state.radio?.isPlaying);
  const isWaveformLoading = useSelector(
    (state: RootState) => state.radio?.isWaveformLoading,
  );

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isWaveformLoading) return;

      if (e.code === "Space") {
        e.preventDefault();
        dispatch(togglePlayPause());
      } else if (e.code === "ArrowLeft") {
        e.preventDefault();
        dispatch(skipBackward());
      } else if (e.code === "ArrowRight") {
        e.preventDefault();
        dispatch(skipForward());
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [dispatch, isWaveformLoading]);

  return (
    <div className={styles.container}>
      <button
        className={styles.controlButton}
        onClick={() => dispatch(skipBackward())}
        disabled={isWaveformLoading}
      >
        <RiReplay10Fill />
      </button>
      <button
        className={styles.controlButton}
        onClick={() => dispatch(togglePlayPause())}
        disabled={isWaveformLoading}
      >
        {isPlaying ? <RiPauseFill /> : <RiPlayFill />}
      </button>
      <button
        className={styles.controlButton}
        onClick={() => dispatch(skipForward())}
        disabled={isWaveformLoading}
      >
        <RiForward10Fill />
      </button>
    </div>
  );
}
